
  import { RadioGroup, Radio } from 'vant';
  import { defineComponent, ref, toRefs, watch } from 'vue';
  import 'vant/es/radio-group/style';
  import 'vant/es/radio/style';
  export interface RadioOptions {
    text: string;
    value: number | string;
  }
  export default defineComponent({
    name: 'BaseRadio',
    components: {
      RadioGroup,
      Radio,
    },
    props: {
      modelValue: {
        type: String,
        default: '',
      },
      options: {
        type: Array as PropType<RadioOptions[]>,
        default: () => [],
      },
    },
    emits: ['change', 'update:modelValue'],
    setup(props, { emit }) {
      const { modelValue } = toRefs(props);
      const checked = ref(modelValue.value);
      watch(checked, () => {
        emit('update:modelValue', checked.value);
      });
      watch(modelValue, () => {
        checked.value = modelValue.value;
      });
      return {
        checked,
      };
    },
  });
